var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 py-3"},_vm._l((_vm.number),function(n,index){return _c('b-skeleton',{key:index,class:_vm.spacing_bottom,attrs:{"animation":"wave","width":"100%","height":_vm.size}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }